// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.cart-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 30px;
}

.cart-items-section {
  min-width: 0;
}

.cart-summary-section {
  min-width: 0;
}

.cart-item-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 15px;
}

.cart-item-details {
  flex: 1 1;
  min-width: 0;
}

.cart-item-price {
  text-align: right;
  min-width: 80px;
  flex-shrink: 0;
}

.quantity-controls {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.quantity-input {
  width: 100px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.quantity-input.error {
  border-color: #dc3545;
}

/* Mobile styles */
@media (max-width: 768px) {
  .cart-container {
    padding: 15px;
  }

  .cart-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .cart-item-content {
    flex-direction: column;
    gap: 10px;
  }

  .cart-item-price {
    text-align: left;
    width: 100%;
  }

  .quantity-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .quantity-controls label {
    margin-bottom: 0;
  }

  .quantity-input {
    width: 100%;
  }

  .quantity-controls button {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .cart-container {
    padding: 10px;
  }

  .cart-container h1 {
    font-size: 24px;
  }

  .cart-grid {
    gap: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/CartPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".cart-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.cart-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n  gap: 30px;\n}\n\n.cart-items-section {\n  min-width: 0;\n}\n\n.cart-summary-section {\n  min-width: 0;\n}\n\n.cart-item-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 15px;\n}\n\n.cart-item-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.cart-item-price {\n  text-align: right;\n  min-width: 80px;\n  flex-shrink: 0;\n}\n\n.quantity-controls {\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.quantity-input {\n  width: 100px;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.quantity-input.error {\n  border-color: #dc3545;\n}\n\n/* Mobile styles */\n@media (max-width: 768px) {\n  .cart-container {\n    padding: 15px;\n  }\n\n  .cart-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .cart-item-content {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .cart-item-price {\n    text-align: left;\n    width: 100%;\n  }\n\n  .quantity-controls {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .quantity-controls label {\n    margin-bottom: 0;\n  }\n\n  .quantity-input {\n    width: 100%;\n  }\n\n  .quantity-controls button {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .cart-container {\n    padding: 10px;\n  }\n\n  .cart-container h1 {\n    font-size: 24px;\n  }\n\n  .cart-grid {\n    gap: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
